import FilterTitle from "../Common/FilterTitle";
import InputFormDouble from "../Common/InputFormDouble";
import InputForm from "../Common/InputForm";
import Checkbox from "../Common/Checkbox";

const Search = () => {
  return (
    <div className="border-b border-darkGreen border-opacity-40 px-2 py-8">
      <FilterTitle title="Search" />
      <Checkbox label={"Only Ads with photos"} className="mb-4" />
      <InputFormDouble
        title={"Price"}
        placeholderMin={"Min"}
        placeholderMax={"Max"}
      />
      <InputForm title={"Search by keywards"} />
    </div>
  );
};
export default Search;
